<div>
  <div class="custom-control custom-radio mb-1">
    <input type="radio"
           id="otpEmailId"
           name="otpEmail"
           class="custom-control-input"
           [(ngModel)]="selectedOption"
           [value]="'email'"/>
    <label class="custom-control-label" for="otpEmailId">{{ 'LOGIN.OTP_EMAIL' | translate }}{{maskedEmail}}</label>
  </div>
  <div [ngbTooltip]="!hasPhoneNumber ? ('RESEND_2FA_TOKEN.NO_PHONE_NUMBER' | translate) : ''" class="custom-control custom-radio mb-1">
    <input type="radio"
           id="otpSmsId"
           name="otpSms"
           class="custom-control-input"
           [disabled]="!hasPhoneNumber"
           [(ngModel)]="selectedOption"
           [value]="'sms'"/>
    <label class="custom-control-label"
           [class.disabled]="!hasPhoneNumber"
           for="otpSmsId">{{ 'LOGIN.OTP_SMS' | translate }}{{maskedPhone}}</label>
  </div>
  <button
    (click)="resendOtp()"
    class="btn btn-primary btn-block mb-1"
    rippleEffect
  >
    {{ 'LOGIN.RESEND_OTP' | translate }}
  </button>
  <a class="a-primary"
     (click)="closeOtpOptions()">
    {{ 'LOGIN.OTP_BACK' | translate }}
  </a>
</div>
